import React from 'react';
import useSeo from '../seo';

const About = () => {
  useSeo('/about');

  return (
    <section className="mn-section" id="about">
      <div className="mn-container">
        <div className="mn-section-head">
          <span className="mn-kicker">Our Story & Philosophy</span>
          <h1>General Ledgers speak in currency. Site managers speak in operations.</h1>
          <p>
            After years of working in finance for large organizations, our founders realized how little visibility there was into true product margins and how poorly budgets were managed. We saw a critical need for a tool that manages this process seamlessly, giving you clear visibility of where you are making profit right down to the SKU level. 
          </p>
          <p style={{ marginTop: '16px' }}>
            Mantle is engineered to run your <strong>Budget, PF (Profit Forecast), and LE (Latest Estimate)</strong> cycles easily. Our core philosophy is simple: we build a product that suits your business, rather than forcing you to change your business to suit the product. We believe in rapid development, continuously adapting the tool to your specific needs, and keeping complex budgets as simple as they need to be.
          </p>
        </div>
        
        <div className="mn-vs">
          <div className="mn-vs-card mn-vs-villain">
            <span className="mn-vs-tag">The Villain</span>
            <h3>The disconnected spreadsheet</h3>
            <p>
              Companies export ERP data into static files to build budgets — breaking the single
              source of truth. Every file shatters the moment a Bill of Materials changes, and
              no one can trust the number.
            </p>
          </div>
          <div className="mn-vs-card mn-vs-hero">
            <span className="mn-vs-tag">The Hero</span>
            <h3>Profit assurance</h3>
            <p>
              Mantle connects the shop floor to the top floor. We replace static, top-down
              guesswork with dynamic, bottom-up precision — starting from the smallest
              operational atom and rolling it up to a scientifically accurate financial picture.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;